import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import firebaseService from '../../services/FirebaseService';

interface FirebaseServiceProviderProps {
  children: React.ReactNode;
}

const FirebaseServiceProvider: React.FC<FirebaseServiceProviderProps> = ({ children }) => {
  const { user } = useAuth();

  useEffect(() => {
    console.log('FirebaseServiceProvider: User state changed', user);
    
    if (user) {
      // Initialize Firebase service with user ID provider
      console.log('Setting user ID provider with UID:', user.uid);
      firebaseService.setUserIdProvider(() => user.uid);
    } else {
      console.log('No user available to set user ID provider');
    }
  }, [user]);

  return <>{children}</>;
};

export default FirebaseServiceProvider;